import * as types from './mutation-types'

export default {
  set({ commit }, data) {
    commit(types.SET, data)
  },
}
